import { useEffect, useState } from 'react';
import type { BadgeDefinition } from '@/types';
import { subscribeBadgeToast } from '@/hooks/useAchievements';
import { BadgeIcon, hasBadgeIcon } from '@/components/BadgeIcon';

interface ToastEntry {
  id: number;
  badge: BadgeDefinition;
}

let nextId = 1;

export function BadgeToast() {
  const [toasts, setToasts] = useState<ToastEntry[]>([]);

  useEffect(() => {
    const unsubscribe = subscribeBadgeToast((badge) => {
      const id = nextId++;
      setToasts((prev) => [...prev, { id, badge }]);
      window.setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 5200);
    });
    return unsubscribe;
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: 88,
        right: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        zIndex: 60,
        pointerEvents: 'none',
      }}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className="badge-toast"
          style={{
            background: 'var(--surface)',
            border: '2px solid var(--accent)',
            borderRadius: 'var(--r-md)',
            padding: '12px 16px',
            display: 'flex',
            gap: 12,
            alignItems: 'center',
            maxWidth: 360,
            fontFamily: 'Inter, sans-serif',
            boxShadow: '0 12px 28px color-mix(in srgb, var(--ink) 30%, transparent)',
            animation: 'badge-toast-in 320ms ease-out',
          }}
        >
          <span style={{ fontSize: 28, lineHeight: 1, display: 'inline-flex' }}>
            {hasBadgeIcon(t.badge.icon) ? (
              <BadgeIcon iconKey={t.badge.icon!} size={30} />
            ) : (
              t.badge.emoji
            )}
          </span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                fontFamily: 'Space Mono, monospace',
                fontSize: 10,
                color: 'var(--accent-deep)',
                textTransform: 'uppercase',
                letterSpacing: 1,
                fontWeight: 700,
              }}
            >
              🏆 Бейдж получен
            </div>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--ink)' }}>{t.badge.name}</div>
            <div style={{ fontSize: 12, color: 'var(--ink-soft)', lineHeight: 1.4 }}>
              {t.badge.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
